module.exports = "/_next/static/images/135bfd738d658d936842ac05b482fc6b-background@1x.png";